export const CODE_BLOCK_DEFAULTS = {
  margin: '0px 0px 0px 0px',
  borderRadius: '10px 10px 10px 10px',
  boxShadow: '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814',
};
